import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=aea8c50a&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea8c50a",
  null
  
)

export default component.exports